import React from 'react'
import { ApplicationContainer } from 'src/components/application-management/ApplicationContainer'

export const ApplicationManagement = () => {
  return <ApplicationContainer />
}
